import { getFieldTemplate } from "./schemaUtil";

export const BILLING_INFO_FORM_SCHEMA = Object.freeze({
	type: "object",
	properties: {
		name: { ...getFieldTemplate("(000) 999 9999") },
		emailAddress: { ...getFieldTemplate("emai@email.com") },
		phoneNumber: { ...getFieldTemplate("(000) 999 9999") },
		addressLine1: { ...getFieldTemplate("Address Line 1") },
		addressLine2: { ...getFieldTemplate("Address Line 2") },
		city: { ...getFieldTemplate("City") },
		state: { ...getFieldTemplate("State/Provide") },
		postalCode: { ...getFieldTemplate("Postal Code") },
		country: { ...getFieldTemplate("country") }
	},
	additionalProperties: false
});
